import angular from 'angular'
import moment from 'moment'
import templateUrl from './edit-schedule-event.component.html'

export const EditScheduleEventComponent = {
    templateUrl,
    controller: EditScheduleEventController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}


export const EditScheduleEventModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexEditScheduleEvent",
    controller: 'EditScheduleEventController',
    controllerAs: "vm",
    size: 'lg',
    backdrop: 'static',
}

export const EditEventHostModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexEditEventHost",
    controller: 'EditEventHostController',
    controllerAs: "vm",
    size: 'lg',
    backdrop: 'static',
}

function EditScheduleEventController($uibModal, $q, utilityService, scheduleEventService, stateProvinceService,
    retailerService, eventHostService) {
    'ngInject'

    const vm = this;
    vm.scheduleEvent;
    vm.retailers;
    vm.$onInit = onInit;
    vm.loaded = false;
    vm.handleSave = handleSave;
    vm.handleCancel = handleCancel;
    vm.stateProvinces = [];
    vm.hostTypes = [];
    vm.divisionID;
    vm.addNewEventHost = addNewEventHost;
    vm.validateDateTime = validateDateTime;
    vm.addNewInstruction = addNewInstruction;
    vm.deleteInstruction = deleteInstruction;
    vm.addNewHourOfOperation = addNewHourOfOperation;
    vm.deleteHourOfOperation = deleteHourOfOperation;
    vm.validateTime = validateTime;
    vm.onChangeWeekDay = onChangeWeekDay;
    vm.allOffDates = [];
    vm.defaultWeekDays = [
        {
            name: "Sun",
            day: 1,
            value: false,
        }, {
            name: "Mon",
            day: 2,
            value: false,
        }, {
            name: "Tue",
            day: 3,
            value: false,
        }, {
            name: "Wed",
            day: 4,
            value: false,
        }, {
            name: "Thu",
            day: 5,
            value: false,
        }, {
            name: "Fri",
            day: 6,
            value: false,
        }, {
            name: "Sat",
            day: 7,
            value: false,
        }];

    function onInit() {
        vm.hostTypes = vm.resolve.hostTypes;
        vm.eventHosts = vm.resolve.eventHosts;
        vm.scheduleEvent = vm.resolve.scheduleEvent;
        vm.divisionID = vm.resolve.divisionID;
        hydrateScheduleEvent(vm.scheduleEvent);
        vm.pristineScheduleEvent = angular.copy(vm.scheduleEvent);
    }

    function hydrateScheduleEvent(scheduleEvent) {
        if (!scheduleEvent.ScheduleEventHoursOfOperations) {
            scheduleEvent.ScheduleEventHoursOfOperations = [];
        }
        scheduleEvent.ScheduleEventHoursOfOperations = groupOperationByTime(
            scheduleEvent.ScheduleEventHoursOfOperations);

        scheduleEvent.EventHost = vm.eventHosts.filter(function (eventHost) {
            return eventHost.EventHostID === scheduleEvent.EventHostID
        })[0];
        scheduleEvent.SpecialInstructions = !scheduleEvent.SpecialInstructions ?
            [] : scheduleEvent.SpecialInstructions.map(function (text) {
                return {
                    Instruction: text
                };
            })
        generateOffDates();
    }

    function groupOperationByTime(scheduleEventHoursOfOperations) {
        return scheduleEventHoursOfOperations.reduce(function (operations, operation) {
            const opr = operations.filter(p => p.OpeningTime.toString("HH:mm:ss") ===
                operation.OpeningTime.toString("HH:mm:ss")
                && p.ClosingTime.toString("HH:mm:ss") ===
                operation.ClosingTime.toString("HH:mm:ss"))[0];
            if (opr != null) {
                const existingOpWeek = opr.WeekDays.filter(p => p.day === operation.Day)[0];
                if (existingOpWeek) {
                    existingOpWeek.value = true;
                }
            } else {
                const newHour = {
                    OpeningTime: operation.OpeningTime,
                    ClosingTime: operation.ClosingTime,
                    WeekDays: angular.copy(vm.defaultWeekDays)
                };
                const existingWeek = newHour.WeekDays.filter(p => p.day === operation.Day)[0];
                if (existingWeek) {
                    existingWeek.value = true;
                }
                operations.push(newHour);
            }
            return operations
        }, []);
    }

    function flattenDays() {
        return vm.scheduleEvent.ScheduleEventHoursOfOperations
            .map(p => p.WeekDays)
            .reduce(function (a, b) {
                return a.concat(b);
            }, [])
            .filter(p => p.value);
    }

    function validateDaysOrder() {
        validateWeekDays();
        const weekDays = flattenDays();
        vm.duplicatedDays = [];
        const distinctDays = weekDays.reduce(function (days, day) {
            const existingDay = days.filter(p => p.day === day.day)[0];
            if (existingDay) {
                vm.duplicatedDays.push(existingDay.name);
            } else {
                days.push(day);
            }
            return days;
        }, []);

        vm.editForm.$setValidity('duplicateDays', !vm.duplicatedDays.length > 0);
        vm.editForm.$setValidity('maxDays', distinctDays.length <= 7);
        return !vm.duplicatedDays.length > 0 && distinctDays.length <= 7;
    }

    function validateWeekDays() {
        vm.scheduleEvent.ScheduleEventHoursOfOperations.forEach(function (op) {
            const activeWeekDays = op.WeekDays.filter(p => p.value);
            if (op.editForm) {
                op.editForm.$setValidity('noDaysDefined', activeWeekDays.length > 0);
            }
        })
    }

    function onChangeWeekDay(operation, weekDay) {
        validateDaysOrder();
    }

    function addNewHourOfOperation() {
        const newOperation = {
            OpeningTime: null,
            ClosingTime: null,
            WeekDays: angular.copy(vm.defaultWeekDays)
        };
        vm.scheduleEvent.ScheduleEventHoursOfOperations.unshift(newOperation);
        validateDaysOrder();
    }

    function deleteHourOfOperation(operation) {
        const index = vm.scheduleEvent.ScheduleEventHoursOfOperations.indexOf(operation);
        if (index > -1) {
            vm.scheduleEvent.ScheduleEventHoursOfOperations.splice(index, 1);
        }
    }

    function hydrateEventHostName(eventHost) {
        const name = eventHost.HostLocationName
            ? `${eventHost.HostName} (${eventHost.HostLocationName})`
            : eventHost.HostName
        eventHost.Text = name;
    }

    function generateOffDates() {
        if (vm.scheduleEvent.StartDate && vm.scheduleEvent.EndDate) {
            const startDate = moment(vm.scheduleEvent.StartDate);
            const endDate = moment(vm.scheduleEvent.EndDate);
            const dates = [];
            if (startDate.isValid() && endDate.isValid()) {
                if (startDate.isAfter(endDate) && vm.editForm) {
                    vm.editForm.startDate.$setValidity("validDate", false);
                } else {
                    const currDate = moment(startDate).startOf('day');
                    const lastDate = moment(endDate).startOf('day');
                    while (currDate.add(1, 'days').diff(lastDate) < 0) {
                        dates.push(currDate.clone().toDate());
                    }
                    if (vm.editForm) {
                        vm.editForm.startDate.$setValidity("validDate", true);
                    }
                }
            }
            vm.allOffDates = dates;
            if (vm.scheduleEvent.OffDates) {
                vm.scheduleEvent.OffDates = vm.scheduleEvent.OffDates.filter(function (date) {
                    const currDate = moment(date);
                    return currDate > startDate && currDate < endDate;
                });
            }
        }
    }

    function addNewEventHost() {
        const retailersLoaded = retailerService.retrieveRetailers();
        const starteProvinceLoaded = stateProvinceService.retrieveStateProvinces();
        utilityService.showLoading();
        return $q.all([retailersLoaded, starteProvinceLoaded])
            .then(function ([retailers, starteProvinces]) {
                utilityService.hideLoading();
                const newEventHost = {
                    Address: {},
                    ContactPhone: {}
                }
                return $uibModal.open({
                    ...EditEventHostModal,
                    resolve: {
                        eventHost: () => newEventHost,
                        retailers: () => retailers,
                        stateProvinces: () => starteProvinces,
                        hostTypes: () => eventHostService.getEventHostTypes(),
                        divisionID: () => vm.divisionID,
                    }
                }).result
                    .then(function (createdEventHost) {
                        refreshEventHostList(createdEventHost);
                    });
            }).catch(function (ex) {
                utilityService.hideLoading();
            });
    }

    function refreshEventHostList(createdEventHost) {
        utilityService.showLoading();
        eventHostService.retrieveEventHosts({ DivisionID: vm.divisionID })
            .then(function (eventHosts) {
                vm.eventHosts = eventHosts;
                vm.eventHosts.forEach(hydrateEventHostName);
                vm.scheduleEvent.EventHost = vm.eventHosts.filter(function (eventHost) {
                    return eventHost.EventHostID === createdEventHost.EventHostID
                })[0];
                utilityService.hideLoading();
                return vm.eventHosts;

            }).catch(function (ex) {
                utilityService.hideLoading();
                alert("Load event host failed: " + (ex.statusText || ex))
            })
    }

    function validateDateTime() {
        generateOffDates();
        validateTime();
    }

    function validateTime() {
        vm.scheduleEvent.ScheduleEventHoursOfOperations.forEach(function (operation) {
            if (operation.OpeningTime && operation.ClosingTime) {
                const startTime = moment(operation.OpeningTime, "HH:mm:ss");
                const endTime = moment(operation.ClosingTime, "HH:mm:ss");
                if (startTime.isAfter(endTime)) {
                    operation.editForm["startTime_" + operation.$id].$setValidity("validTime", false);
                } else {
                    operation.editForm["startTime_" + operation.$id].$setValidity("validTime", true);
                }
            }
        });

        validateDaysOrder();
    }
    function mapHoursOfOperation(hoursOfOperations) {
        return hoursOfOperations.reduce(function (operations, operation) {
            const activeDays = operation.WeekDays.filter(p => p.value);
            activeDays.forEach(function (day) {
                day.OpeningTime = operation.OpeningTime.toString("HH:mm:ss");
                day.ClosingTime = operation.ClosingTime.toString("HH:mm:ss")
            });
            return operations.concat(activeDays)
        }, []);
    }

    function handleSave() {
        utilityService.showLoading();
        (function () {
            const command = {
                DivisionID: vm.divisionID,
                StartDate: vm.scheduleEvent.StartDate,
                HoursOfOperations: mapHoursOfOperation(vm.scheduleEvent.ScheduleEventHoursOfOperations),
                EndDate: vm.scheduleEvent.EndDate,
                RetailerID: vm.scheduleEvent.EventHost.RetailerID,
                EventHostID: vm.scheduleEvent.EventHost.EventHostID,
                SpecialInstructionsJson: JSON.stringify(vm.scheduleEvent.SpecialInstructions.map(function (ins) {
                    return ins.Instruction;
                })),
                OffDatesJson: JSON.stringify(vm.scheduleEvent.OffDates)
            };
            if (!vm.scheduleEvent.ScheduleEventID) {
                return scheduleEventService.createScheduleEvent(command);
            } else {
                return scheduleEventService.updateScheduleEvent(vm.scheduleEvent.ScheduleEventID, command);
            }
        })()
            .then(function () {
                vm.close({ $value: vm.scheduleEvent });
            })
            .catch(function (ex) {
                alert("Saving event host failed: " + (ex.statusText || ex))
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function handleCancel() {
        vm.dismiss({ $value: 'cancel' });
    }

    function addNewInstruction() {
        vm.scheduleEvent.SpecialInstructions.push({ Instruction: '' });
    }

    function deleteInstruction(instruction) {
        const index = vm.scheduleEvent.SpecialInstructions.indexOf(instruction);
        if (index > -1) {
            vm.scheduleEvent.SpecialInstructions.splice(index, 1);
        }
    }

}
